import React from 'react';
import c from '../w.js';

const IconAlertFilled = React.memo(
  c(
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.37753 4.66124C10.5205 2.60381 13.4795 2.6038 14.6225 4.66123L21.2234 16.543C22.3343 18.5426 20.8884 20.9999 18.601 20.9999H5.39903C3.11158 20.9999 1.66567 18.5426 2.77656 16.543L9.37753 4.66124ZM11 7.99988V13.9999H13V7.99988H11ZM11 15.9999V17.9999H13V15.9999H11Z"
      }
    )
  )
);

export { IconAlertFilled };
